import Layer from './Layer';
import CanvasLayer from './CanvasLayer';
import SymbolLayer from './SymbolLayer';
import VectorLayer from './VectorLayer';
import VectorTileLayer from './VectorTileLayer';
import PartitionLayer from './PartitionLayer'
import TransformLayer from './TransformLayer'

export default {
    Layer,
    CanvasLayer,
    SymbolLayer,
    VectorLayer,
    VectorTileLayer,
    PartitionLayer,
    TransformLayer
};
